/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerBeneficiariesDtoApiResponse } from '../../models/customer-beneficiaries-dto-api-response';

export interface GetCustomerBeneficiaryAsync$Params {
  beneficiaryId: number;
  id: number;
}

export function getCustomerBeneficiaryAsync(http: HttpClient, rootUrl: string, params: GetCustomerBeneficiaryAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerBeneficiariesDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, getCustomerBeneficiaryAsync.PATH, 'get');
  if (params) {
    rb.path('beneficiaryId', params.beneficiaryId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerBeneficiariesDtoApiResponse>;
    })
  );
}

getCustomerBeneficiaryAsync.PATH = '/api/customer/{id}/beneficiary/{beneficiaryId}';
